import { useQuery } from '@tanstack/react-query';

import { listQueryOptions } from '@/lib/query-client';
import { makeQueryKeys } from '@/lib/query-keys';

import { exercisesService } from '../services';
import type { ExerciseListParams } from '../types';

export const exercisesKeys = makeQueryKeys('exercises');
export const clientExercisesKeys = makeQueryKeys('client-exercises');

export function useExercises(params: ExerciseListParams = {}) {
  return useQuery({
    queryKey: exercisesKeys.list(params),
    queryFn: () => exercisesService.list(params),
    ...listQueryOptions,
  });
}
